import { CsrfToken } from '../../core/hooks/useCsrfToken';
import { clientApi } from '../clientApi';

export type DealNameValidateInputs = { title: string };
export type DealNameValidateRequest = DealNameValidateInputs & CsrfToken;
export type DealNameValidateResponse = { message: string };

export async function dealTitleValidate(values: DealNameValidateRequest) {
    return await clientApi
        .post('deal-title-validation/', {
            json: values,
        })
        .json<DealNameValidateResponse>();
}
